export function zoomWindow(length, zoom = 1, start = 0) {
    const count = Math.min(length, Math.max(2, Math.ceil(length / zoom)));
    const maxStart = length - count;
    const first = Math.max(0, Math.min(maxStart, Math.round(start)));
    return { start: first, end: first + count, count, maxStart };
}

export function changeZoom(length, current, delta) {
    const zoom = Math.max(1, Math.min(4, current.zoom + delta));
    const previous = zoomWindow(length, current.zoom, current.start);
    const next = zoomWindow(length, zoom);
    return { zoom, start: zoomWindow(length, zoom, previous.end - next.count).start };
}
